export const FETCH_USER = 'fetchUser'
